const galeriaImages = [
  { id: 1, src: require("../images/Galeria/img_01.jpg")},
  { id: 2, src: require("../images/Galeria/img_33.jpg")},
  { id: 3, src: require("../images/Galeria/img_08.jpg")},
  { id: 4, src: require("../images/Galeria/img_09.jpg")},
  { id: 5, src: require("../images/Galeria/img_10.jpg")},
  { id: 6, src: require("../images/Galeria/img_11.jpg")},
  { id: 7, src: require("../images/Galeria/img_12.jpg")},
  { id: 8, src: require("../images/Galeria/img_13.jpg")},
  { id: 9, src: require("../images/Galeria/img_14.jpg")},
  { id: 10, src: require("../images/Galeria/img_15.jpg")},
  { id: 11, src: require("../images/Galeria/img_17.jpg")},
  { id: 12, src: require("../images/Galeria/img_18.jpg")},
  { id: 13, src: require("../images/Galeria/img_19.jpg")},
  { id: 14, src: require("../images/Galeria/img_20.jpg")},
  { id: 15, src: require("../images/Galeria/img_21.jpg")},
  { id: 16, src: require("../images/Galeria/img_22.jpg")},
  { id: 17, src: require("../images/Galeria/img_23.jpg")},
  { id: 18, src: require("../images/Galeria/img_24.jpg")},
  { id: 19, src: require("../images/Galeria/img_25.jpg")},
  { id: 20, src: require("../images/Galeria/img_26.jpg")},
  { id: 21, src: require("../images/Galeria/img_27.jpg")},
  { id: 22, src: require("../images/Galeria/img_28.jpg")},
  { id: 23, src: require("../images/Galeria/img_29.jpg")},
  { id: 24, src: require("../images/Galeria/img_30.jpg")},
  { id: 25, src: require("../images/Galeria/img_31.jpg")},
  { id: 26, src: require("../images/Galeria/img_32.jpg")},
  { id: 27, src: require("../images/Galeria/img_35.jpg")},
  { id: 28, src: require("../images/Galeria/img_36.jpg")},
  { id: 29, src: require("../images/Galeria/img_37.jpg")},
  { id: 30, src: require("../images/Galeria/img_38.jpg")},
  { id: 31, src: require("../images/Galeria/img_39.jpg")},
  { id: 32, src: require("../images/Galeria/img_40.jpg")},
  { id: 33, src: require("../images/Galeria/img_41.jpg")},
  { id: 34, src: require("../images/Galeria/img_42.jpg")},
  { id: 35, src: require("../images/Galeria/img_43.jpg")},
  { id: 36, src: require("../images/Galeria/img_44.jpg")},
  { id: 37, src: require("../images/Galeria/img_45.jpg")},
  { id: 38, src: require("../images/Galeria/img_47.jpg")},
  { id: 39, src: require("../images/Galeria/img_48.jpg")},
  { id: 40, src: require("../images/Galeria/img_49.jpg")},
  { id: 41, src: require("../images/Galeria/img_50.jpg")},
  { id: 42, src: require("../images/Galeria/img_51.jpg")},
  { id: 43, src: require("../images/Galeria/img_52.jpg")},
  { id: 44, src: require("../images/Galeria/img_53.jpg")},
  { id: 45, src: require("../images/Galeria/img_54.jpg")},
  { id: 46, src: require("../images/Galeria/img_55.jpg")},
  { id: 47, src: require("../images/Galeria/img_56.jpg")},
  { id: 48, src: require("../images/Galeria/img_57.jpg")},
  { id: 49, src: require("../images/Galeria/img_58.jpg")},
  { id: 50, src: require("../images/Galeria/img_60.jpg")},
  { id: 51, src: require("../images/Galeria/img_61.jpg")},
  { id: 52, src: require("../images/Galeria/img_62.jpg")},
  { id: 52, src: require("../images/Galeria/img_63.jpg")},
  { id: 52, src: require("../images/Galeria/img_64.jpg")},
  { id: 52, src: require("../images/Galeria/img_65.jpg")},
  { id: 52, src: require("../images/Galeria/img_66.jpg")},
  { id: 52, src: require("../images/Galeria/img_67.jpg")},
  { id: 52, src: require("../images/Galeria/img_68.jpg")},
  { id: 52, src: require("../images/Galeria/img_69.jpg")},
  { id: 52, src: require("../images/Galeria/img_70.jpg")},
  { id: 52, src: require("../images/Galeria/img_71.jpg")},
  { id: 52, src: require("../images/Galeria/img_72.jpg")},
  { id: 52, src: require("../images/Galeria/img_73.jpg")},
  { id: 52, src: require("../images/Galeria/img_74.jpg")},
  { id: 52, src: require("../images/Galeria/img_75.jpg")},
  { id: 52, src: require("../images/Galeria/img_76.jpg")},
  { id: 52, src: require("../images/Galeria/img_77.jpg")},
  { id: 52, src: require("../images/Galeria/img_78.jpg")},
  { id: 52, src: require("../images/Galeria/img_79.jpg")},
  { id: 52, src: require("../images/Galeria/img_80.jpg")},
  { id: 52, src: require("../images/Galeria/img_81.jpg")},
  
  { id: 52, src: require("../images/Galeria/img_83.jpg")},
  { id: 52, src: require("../images/Galeria/img_84.jpg")},
  { id: 52, src: require("../images/Galeria/img_85.jpg")},
  { id: 52, src: require("../images/Galeria/img_86.jpg")},
  { id: 52, src: require("../images/Galeria/img_87.jpg")},
  { id: 52, src: require("../images/Galeria/img_88.jpg")},
  


  // Agregás más fácilmente
];

export default galeriaImages;
